/* src/app/module/service-provider/add-sp-new-component/add-sp/add-sp.component.scss */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal {
  background-color: white;
  padding: 0;
  border-radius: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.img img {
  width: 122px;
}
.cross-icon {
  margin: 0px 16px 0px 12px;
}
.sidebar {
  height: 100vh;
  position: fixed;
  top: 0;
  border-right: 1px solid #F2F4F7;
  padding-left: 52px;
}
.sidebar ul {
  list-style-type: none;
  padding: 0;
  margin: 0px;
  margin-top: 32px;
}
.sidebar ul li {
  padding: 8px 12px;
}
.sidebar ul li a {
  text-decoration: none;
  display: block;
  font-size: 16px;
  display: flex;
  align-items: center;
  padding: 6px;
  border-radius: 4px;
}
.sidebar ul li a i {
  margin-right: 10px;
}
.sidebar ul li a.active {
  color: var(--Gray-900, #101828);
  font-weight: 900;
}
.sidebar ul li a {
  color: var(--Gray-500, #667085);
  font-weight: 500;
}
.content {
  margin-left: 300px;
  padding: 32px 0px 0px 32px;
  flex-grow: 1;
  overflow-y: auto;
}
.content.no-scroll {
  overflow-y: hidden !important;
}
.content > * {
  max-width: 100%;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  cursor: pointer;
}
a {
  text-decoration: none;
  display: block;
}
.disabled-link {
  color: #888;
  cursor: not-allowed;
  pointer-events: none;
}
/*# sourceMappingURL=add-sp.component-FFPBJI55.css.map */
